<template lang="pug">
div.small-space
  .reference-name {{initBlock.config.label}}
  //- pre {{initBlock }}
  b-field(label="Button Beschriftung" label-position="on-border" :maxlength="255")
    b-input(:value="initBlock.value.title" @input="(val) => updateValue({title: val})")
  b-field(label="Externer Link (optional)" textarea label-position="on-border" :maxlength="255" grouped)
    b-input(:value="initBlock.value.externalLink" @input="(val) => updateValue(val)")
    p.control
      b-button(type="is-flat" @click="show = true") Interne Seite verlinken
      .space.md
      b-tag(v-if="initBlock.value.internalPageId" type="is-success") Interner Link auf "{{initBlock.value.internalPageName}}"
  b-modal(v-model="show"
        has-modal-card
        :full-screen="false" 
        :can-cancel="true")
    SelectInternalPageModal(@select="(data) => updateValue(data)")
</template>

<script>

import SelectInternalPageModal from "@/components/molecules/SelectInternalPageModal.vue";

export default {
  components: {
    SelectInternalPageModal
  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            titel: null,
            internalPageId: null,
            externalLink: null
          },
          config: {
            label: "Click-To-Action"
          }
        }
      }
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    updateValue(e) {
      let internalPageId = this.initBlock.value ? this.initBlock.value.internalPageId : "";
      let externalLink = this.initBlock.value ? this.initBlock.value.externalLink : "";
      let title = this.initBlock.value ? this.initBlock.value.title : "";
      let internalPageName;

      if (e.pageType) {
        internalPageId = e.id;
        internalPageName = e.name;
        externalLink = null;
      } else if (e.title) {
        title = e.title
      } else {
        externalLink = e;
        internalPageId = null
      }

      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          title,
          internalPageId,
          externalLink,
          internalPageName
        }
      });    
      this.show = false;
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.small-space {
  margin-bottom: 12px;
}

.reference-name {
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>